import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SimulatorService } from './../../../pre-simulator/services/simulator/simulator.service';

import { Observable, of } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';
import { CountryModel } from '../../../pre-simulator/models/country.model';
import { ModalGenericComponent } from '../../../shared/components/modal-generic/modal-generic.component';
import { Holder } from '../../../shared/models/user-data.model';
import { UserDataService } from '../../../shared/services/user-data/user-data.service';
import {
  EMAIL_REGEXP,
  ES_MOBILE_PHONE_REGEXP,
  ES_POSTAL_CODE_REGEXP,
  VALIDATORS_LENGTH,
} from '../../../shared/utils/constants';
import { CustomValidators } from '../../../shared/utils/custom-validators';
import { ConfirmationService } from '../../../vass-core/components/modal/confirmation.service';
import { validateNoSpaces } from '../../../vass-core/validators/no-spaces.validator';
import { SelectModel } from '../../models/select.model';
import { LayoutService } from '../../services/layout/layout.service';
import { MortgageService } from '../../services/mortgage/mortgage.service';
import { HousingDataFormComponent } from '../housing-data-form/housing-data-form.component';

@Component({
  selector: 'app-advance-simulator-form',
  templateUrl: './advance-simulator-form.component.html',
  styleUrls: ['./advance-simulator-form.component.scss'],
  standalone: false,
})
export class AdvanceSimulatorFormComponent implements OnInit {
  @ViewChild('formHousingData', { static: true })
  formHousingData: HousingDataFormComponent;

  @Output() emitForm: EventEmitter<UntypedFormGroup> = new EventEmitter();
  @Output() onSaveForm: EventEmitter<Object> = new EventEmitter();
  @Output() returnHttpError: EventEmitter<boolean> = new EventEmitter();

  public HTML_VALIDATORS = VALIDATORS_LENGTH;
  public advanceSimulatorForm;
  public mortgageForm: UntypedFormGroup;
  public titulares: UntypedFormArray;
  public listDocumentType: any;
  public listMaritalStatus$: Observable<SelectModel[]>;
  public listEmploymentSituation$: Observable<SelectModel[]>;
  public listSeniorityCompany$: Observable<SelectModel[]>;
  public listEconomicSystem$: Observable<SelectModel[]>;
  public listActivitySector$: Observable<SelectModel[]>;
  public listAcademicLevel$: Observable<SelectModel[]>;
  public listProfessionalLevel$: Observable<SelectModel[]>;

  public maxIncomeByholder = 1000000;

  validatorsForm = {
    expensesOtherLoad: [],
    membersFamily: [Validators.maxLength(this.HTML_VALIDATORS.maxLength.membersFamily)],
    titular: {
      name: [Validators.minLength(this.HTML_VALIDATORS.minLength)],
      firstSurname: [],
      secondSurname: [],
      birthDate: [],
      idType: [],
      idNumber: [CustomValidators.validateDocument('BOTH'), this.difetentDocument()],
      email: [Validators.required, Validators.pattern(EMAIL_REGEXP)],
      phone: [Validators.pattern(ES_MOBILE_PHONE_REGEXP)],
      maritalStatus: [],
      gender: [],
      nationality: [],
      country: [],
      economicRegimeBeforeDivorce: [],
      holderEmploymentData: {
        monthlyIncome: [],
        otherIncome: [],
        companyName: [],
        employmentSituation: [],
        laborSeniority: [],
        activitySector: [],
        academicLevel: [],
        professionalLevel: [],
      },
    },
    addressData: {
      roadType: [],
      roadName: [
        Validators.minLength(this.HTML_VALIDATORS.minLength),
        Validators.maxLength(this.HTML_VALIDATORS.maxLength.roadName),
      ],
      roadNumber: [Validators.maxLength(this.HTML_VALIDATORS.maxLength.roadNumber)],
      doorway: [Validators.maxLength(this.HTML_VALIDATORS.maxLength.doorway)],
      floor: [Validators.maxLength(this.HTML_VALIDATORS.maxLength.floor)],
      door: [Validators.maxLength(this.HTML_VALIDATORS.maxLength.door)],
      zip: [
        Validators.maxLength(5),
        Validators.minLength(5),
        Validators.pattern(ES_POSTAL_CODE_REGEXP),
        validateNoSpaces,
      ],
      city: [],
    },
  };

  public date = new Date();
  public configCalendar = {
    dtBirhDate: {
      yearRange: '',
      maxDate: new Date(
        this.date.getFullYear() - 21,
        this.date.getMonth(),
        this.date.getDate(),
      ),
      minDate: new Date(
        this.date.getFullYear() - 100,
        this.date.getMonth(),
        this.date.getDate(),
      ),
    },
  };

  public defaultBirthDate: Date = new Date(
    this.date.getFullYear() - 21,
    this.date.getMonth(),
    this.date.getDate(),
  );

  public countries$: Observable<CountryModel[]>;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private _userDataService: UserDataService,
    private _mortgageService: MortgageService,
    private _layoutService: LayoutService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
    private simulatorService: SimulatorService,
  ) {
    const fechaAux = new Date();
    this.configCalendar.dtBirhDate.yearRange = `${
      fechaAux.getFullYear() - 100
    }:${fechaAux.getFullYear() - 21}`;
  }

  ngOnInit() {
    this.createadvanceSimulatorForm();
    this.getStaticFormData();
    this.subscribeUserDataChanges();
  }

  private createadvanceSimulatorForm() {
    this.advanceSimulatorForm = this.formBuilder.group({
      titularNumber: [''],
      expensesOtherLoad: ['', this.validatorsForm.expensesOtherLoad],
      membersFamily: ['', this.validatorsForm.membersFamily],
    });

    this.emitForm.emit(this.advanceSimulatorForm);
  }

  private getStaticFormData() {
    this.listDocumentType = this._mortgageService.getDocumentType();
    this.listMaritalStatus$ = this._mortgageService.getMaritalStatus();
    this.listEmploymentSituation$ = this._mortgageService.getEmploymentSituation();
    this.listSeniorityCompany$ = this._mortgageService.getSeniorityCompany();
    this.listEconomicSystem$ = this._mortgageService.getEconomicSystem();
    this.listActivitySector$ = this._mortgageService.getActivitySector();
    this.listAcademicLevel$ = this._mortgageService.getAcademicLevel();
    this.listProfessionalLevel$ = this._mortgageService.getProfessionalLevel();
    this.countries$ = this.simulatorService.getCountries();
  }

  private subscribeUserDataChanges() {
    this._layoutService.recoverUserData().subscribe(
      (userData: any) => {
        this._userDataService.mapperUserData(userData);
        this.setValuesUserData();
        if (userData.level2Data) {
          this.advanceSimulatorForm.patchValue(userData.level2Data);
        }
      },
      (error) => {
        this.returnHttpError.emit(true);
      },
    );
  }

  private setValuesUserData() {
    const userData = this._userDataService.getUserData();

    this.titulares = this.formBuilder.array([]);
    this.titulares.setControl(0, this.createTitularForm(userData.level2Data.holders[0]));
    if (userData.level2Data.holders.length === 2) {
      this.titulares.setControl(
        1,
        this.createTitularForm(userData.level2Data.holders[1]),
      );
    }
    this.advanceSimulatorForm.setControl('holders', this.titulares);
    this.advanceSimulatorForm.patchValue(userData.level2Data);

    // Actualizar el validador
    this.advanceSimulatorForm.get('holders').controls.forEach((holder, index) => {
      this.updateValidatorIdType(holder, index);
    });
  }

  public updateValidatorIdType(holder: UntypedFormGroup, indice?: number) {
    if ('DOC_TYP_NIF' === holder.controls.idType.value) {
      holder.controls.idNumber.setAsyncValidators([
        CustomValidators.validateDocument('DNI'),
      ]);
      holder.get('nationality').setValue('ESP');
      holder.get('nationality').disable();
    } else if ('DOC_TYP_NIE' === holder.controls.idType.value) {
      holder.controls.idNumber.setAsyncValidators([
        CustomValidators.validateDocument('NIE'),
      ]);
      holder.get('nationality').enable();
      if (holder.get('nationality').value === 'ESP') {
        holder.get('nationality').setValue('');
      }
    } else {
      holder.controls.idNumber.setAsyncValidators([
        CustomValidators.validateDocument('BOTH'),
      ]);
      holder.get('nationality').enable();
    }
    if (!indice || (indice === 1 && holder.controls.idNumber.value !== '')) {
      holder.controls.idNumber.markAsTouched();
    }
    holder.controls.idNumber.updateValueAndValidity();
  }

  private createTitularForm(titularData?: any) {
    const titular = this.formBuilder.group(
      {
        name: ['', this.validatorsForm.titular.name],
        firstSurname: ['', this.validatorsForm.titular.firstSurname],
        secondSurname: ['', this.validatorsForm.titular.secondSurname],
        birthDate: ['', this.validatorsForm.titular.birthDate],
        idType: ['', this.validatorsForm.titular.idType],
        idNumber: ['', Validators.required],
        email: ['', this.validatorsForm.titular.email],
        phone: ['', this.validatorsForm.titular.phone],
        maritalStatus: ['', this.validatorsForm.titular.maritalStatus],
        gender: [''],
        nationality: [''],
        country: [''],
        economicRegimeBeforeDivorce: [
          '',
          this.validatorsForm.titular.economicRegimeBeforeDivorce,
        ],

        holderEmploymentData: this.formBuilder.group({
          monthlyIncome: [
            '',
            this.validatorsForm.titular.holderEmploymentData.monthlyIncome,
          ],
          otherIncome: ['', this.validatorsForm.titular.holderEmploymentData.otherIncome],
          companyName: ['', this.validatorsForm.titular.holderEmploymentData.companyName],
          employmentSituation: [
            '',
            this.validatorsForm.titular.holderEmploymentData.employmentSituation,
          ],
          laborSeniority: [
            '',
            this.validatorsForm.titular.holderEmploymentData.laborSeniority,
          ],
          activitySector: [
            '',
            this.validatorsForm.titular.holderEmploymentData.activitySector,
          ],
          academicLevel: [
            '',
            this.validatorsForm.titular.holderEmploymentData.academicLevel,
          ],
          professionalLevel: [
            '',
            this.validatorsForm.titular.holderEmploymentData.professionalLevel,
          ],
        }),

        holderAddress: this.formBuilder.group({
          roadType: ['', this.validatorsForm.addressData.roadType],
          roadName: ['', this.validatorsForm.addressData.roadName],
          roadNumber: ['', this.validatorsForm.addressData.roadNumber],
          doorway: ['', this.validatorsForm.addressData.doorway],
          floor: ['', this.validatorsForm.addressData.floor],
          door: ['', this.validatorsForm.addressData.door],
          zip: ['', this.validatorsForm.addressData.zip],
          city: ['', this.validatorsForm.addressData.city],
        }),
      },
      { validator: this.maxIncome },
    );

    titular.controls['idNumber'].setAsyncValidators(this.validatorsForm.titular.idNumber);
    titular.controls['email'].setAsyncValidators(this.difetentEmail());
    if (titularData) {
      if (!titularData.holderEmploymentData.otherIncome) {
        titularData.holderEmploymentData.otherIncome = '';
      }
      titular.patchValue(titularData);
    }
    return titular;
  }

  public addOtherTitular() {
    const userData = this._userDataService.getUserData();

    if (userData.level2Data.holders.length < 2) {
      this.titulares.setControl(this.titulares.length, this.createTitularForm());
      this.advanceSimulatorForm.setControl('holders', this.titulares);
      // Si no existe el segundo titular se añade
      if (!userData.level2Data.holders[1]) {
        userData.level2Data.holders.push(new Holder());
      }
      this.advanceSimulatorForm.controls['titularNumber'].setValue(2);
      setTimeout(() => {
        if (document.getElementById('form-holder-1')) {
          document.getElementById('form-holder-1').scrollIntoView({ behavior: 'smooth' });
        }
      }, 300);
    }
  }

  deleteUser() {
    const userData = this._userDataService.getUserData();
    if (userData.level2Data.holders.length === 2) {
      if (userData.level2Data.holders[1]) {
        this.titulares.removeAt(1);
        userData.level2Data.holders.pop();
      }
      this.advanceSimulatorForm.controls['titularNumber'].setValue(1);
    }
  }

  /**
   * si el primer titular está casado en gananciales o separado de hecho los titulares deben ser 2
   */
  public updateMaritalStatus() {
    const titular: any = this.advanceSimulatorForm.controls.holders;
    if (
      (titular.controls[0].controls.maritalStatus.value === 'marriedAcquisitions' ||
        titular.controls[0].controls.maritalStatus.value === 'deFactoSeparated') &&
      this.titulares.length === 1
    ) {
      this.advanceSimulatorForm.controls.titularNumber.setValue('2');
      this.addOtherTitular();
    }
  }

  /**
   * Este método se utiliza para fijar la validación del campo 'nombre de la empresa' que es obligatorio en caso de que sea indefinido.
   * @param titular FormGroup del titular
   */
  public updateCompanyName(titular: any) {
    titular.controls.employmentSituation.value === 'LAB_SIT_INDE'
      ? titular.controls.companyName.setValidators([Validators.required])
      : titular.controls.companyName.setValidators([]);
    titular.controls['companyName'].updateValueAndValidity();
  }

  /**
   * Fija los campos como requeridos cuando el usuario intenta avanzar el estado a fase 3
   */
  public setValidatorRequired() {
    for (const campo in this.advanceSimulatorForm.controls) {
      if (campo === 'holders') {
        this.setRequiredTitularesForm();
      } else if (campo === 'housingData') {
        this.formHousingData.setValidatorRequired();
      } else if (campo === 'mortgageForm') {
      } else {
        if (this.validatorsForm[campo]) {
          const validatorsAux = this.validatorsForm[campo].slice(0);
          validatorsAux.push(Validators.required);
          this.advanceSimulatorForm.controls[campo].setValidators(validatorsAux);
          this.advanceSimulatorForm.controls[campo].updateValueAndValidity();
          this.advanceSimulatorForm.controls[campo].markAsTouched();
        }
      }
    }
  }

  public resetValidator() {
    for (const campo in this.advanceSimulatorForm.controls) {
      if (campo === 'holders') {
        for (let i = 0; i < this.titulares.length; i++) {
          const item: any = this.titulares.controls[i];
          for (const nameCampo in item.controls) {
            switch (nameCampo) {
              case 'idNumber': {
                item.controls[nameCampo].setValidators([Validators.required]);
                item.controls[nameCampo].setAsyncValidators(
                  this.validatorsForm.titular.idNumber,
                );
                this.updateValidatorIdType(item);
                break;
              }
              case 'holderAddress': {
                const addressForm = item.controls[nameCampo];
                this.resetValidatosAddressForm(addressForm);
                break;
              }
              case 'holderEmploymentData': {
                const holderEmploymentData = item.controls[nameCampo];
                this.resetValidatosEmploymentData(holderEmploymentData);
                break;
              }
              default: {
                item.controls[nameCampo].setValidators(
                  this.validatorsForm.titular[nameCampo],
                );
              }
            }
            item.controls[nameCampo].markAsTouched();
            item.controls[nameCampo].updateValueAndValidity();
            item.controls[nameCampo].markAsTouched();
          }
        }
      } else if (campo === 'housingData') {
        this.formHousingData.resetValidator();
      } else {
        this.advanceSimulatorForm.controls[campo].setValidators(
          this.validatorsForm[campo],
        );
        this.advanceSimulatorForm.controls[campo].updateValueAndValidity();
      }
    }
  }

  public setFormHousingData(form) {
    this.advanceSimulatorForm.setControl('housingData', form);
  }

  public setRequiredTitularesForm() {
    for (let i = 0; i < this.titulares.length; i++) {
      const item: any = this.titulares.controls[i];
      for (const nameCampo in item.controls) {
        switch (nameCampo) {
          case 'secondSurname': {
            if (item.get('idType').value === 'DOC_TYP_NIF') {
              item.controls[nameCampo].setValidators([Validators.required]);
            }
            break;
          }
          case 'holderAddress': {
            const addressDataForm = item.controls[nameCampo];
            this.setRequiredAddressForm(addressDataForm);
            break;
          }
          case 'holderEmploymentData': {
            const holderEmploymentData = item.controls[nameCampo];
            this.setRequiredEmploymentData(holderEmploymentData);
            break;
          }
          case 'economicRegimeBeforeDivorce': {
            item.controls['maritalStatus'].value === 'CIV_STA_DEFA'
              ? item.controls[nameCampo].setValidators([Validators.required])
              : item.controls[nameCampo].setValidators([]);
            break;
          }
          case 'idNumber': {
            item.controls[nameCampo].setValidators([Validators.required]);
            item.controls[nameCampo].setAsyncValidators(
              this.validatorsForm.titular.idNumber,
            );
            this.updateValidatorIdType(item);
            break;
          }
          default: {
            item.controls[nameCampo].validator
              ? item.controls[nameCampo].setValidators([
                  item.controls[nameCampo].validator,
                  Validators.required,
                ])
              : item.controls[nameCampo].setValidators([Validators.required]);
          }
        }
        item.controls[nameCampo].updateValueAndValidity();
        item.controls[nameCampo].markAsTouched();
      }
    }
  }

  private setRequiredEmploymentData(holderEmploymentData: UntypedFormGroup) {
    for (const campo in holderEmploymentData.controls) {
      const validatorsAux =
        this.validatorsForm.titular.holderEmploymentData[campo].slice(0);
      if (campo === 'companyName') {
        this.updateCompanyName(holderEmploymentData);
      } else if (campo === 'otherIncome') {
      } else {
        validatorsAux.push(Validators.required);
        holderEmploymentData.controls[campo].setValidators(validatorsAux);
      }
      holderEmploymentData.controls[campo].updateValueAndValidity();
      holderEmploymentData.controls[campo].markAsTouched();
    }
  }

  private resetValidatosEmploymentData(holderEmploymentData: UntypedFormGroup) {
    for (const campo in holderEmploymentData.controls) {
      holderEmploymentData.controls[campo].setValidators(
        this.validatorsForm.titular.holderEmploymentData[campo],
      );
      holderEmploymentData.controls[campo].updateValueAndValidity();
      holderEmploymentData.controls[campo].markAsTouched();
    }
  }

  private setRequiredAddressForm(addressForm: UntypedFormGroup) {
    for (const campo in addressForm.controls) {
      switch (campo) {
        case 'roadNumber':
        case 'doorway':
        case 'floor':
        case 'door': {
          addressForm.controls[campo].updateValueAndValidity();
          addressForm.controls[campo].markAsTouched();
          break;
        }
        default: {
          const validatorsAux = this.validatorsForm.addressData[campo].slice(0);
          validatorsAux.push(Validators.required);
          addressForm.controls[campo].setValidators(validatorsAux);
          addressForm.controls[campo].updateValueAndValidity();
          addressForm.controls[campo].markAsTouched();
        }
      }
    }
  }

  private resetValidatosAddressForm(addressForm: UntypedFormGroup) {
    for (const campo in addressForm.controls) {
      addressForm.controls[campo].setValidators(this.validatorsForm.addressData[campo]);
      addressForm.controls[campo].updateValueAndValidity();
      addressForm.controls[campo].markAsTouched();
    }
  }

  setMortgageForm(mortgageForm) {
    this.mortgageForm = mortgageForm;
  }

  saveMortgageData() {
    this.advanceSimulatorForm.setControl('mortgageForm', this.mortgageForm);
    this.resetValidator();
    if (this.mortgageForm.valid && this.mortgageForm.dirty) {
      this._userDataService.setLevel1Data(this.mortgageForm.value);
      // Marcar como prestine para evitar que pueda guardar varias veces los mismos datos...
      this.mortgageForm.markAsPristine();
    } else {
      for (const campo in this.mortgageForm.controls) {
        this.mortgageForm.controls[campo].markAsTouched();
      }
    }
  }

  saveCommonData() {
    this.resetValidator();
    const housingData: any = this.advanceSimulatorForm.controls['housingData'];
    if (
      housingData.valid &&
      (housingData.dirty ||
        this.advanceSimulatorForm.controls['membersFamily'].dirty ||
        this.advanceSimulatorForm.controls['titularNumber'].dirty ||
        this.advanceSimulatorForm.controls['expensesOtherLoad'].dirty)
    ) {
      const item = housingData.value;
      item.membersFamily = this.advanceSimulatorForm.controls['membersFamily'].value;
      item.titularNumber = this.advanceSimulatorForm.controls['titularNumber'].value;
      item.expensesOtherLoad =
        this.advanceSimulatorForm.controls['expensesOtherLoad'].value;
      this._userDataService.setLevel2Data(item);
      this.onSaveForm.emit();
      this.addOtherTitular();
    } else {
      for (const campo in housingData.controls) {
        housingData.controls[campo].markAsTouched();
      }
    }
  }

  savePersonalDataHolder(holder: UntypedFormGroup, index: number) {
    this.resetValidator();
    const campos = [
      'name',
      'firstSurname',
      'secondSurname',
      'birthDate',
      'idType',
      'idNumber',
      'email',
      'phone',
      'maritalStatus',
      'economicRegimeBeforeDivorce',
    ];
    let hasValid = true,
      hasDirty = false;
    for (const campo in campos) {
      if (!holder.controls[campos[campo]].valid) {
        hasValid = false;
      }
      if (holder.controls[campos[campo]].dirty) {
        hasDirty = true;
      }
    }
    if (hasDirty && hasValid) {
      Object.assign(this._userDataService.getUserData().level2Data.holders[index], {
        name: holder.controls.name.value.trim(),
        firstSurname: holder.controls.firstSurname.value.trim(),
        secondSurname: holder.controls.secondSurname.value.trim(),
        birthDate: holder.controls.birthDate.value,
        idType: holder.controls.idType.value,
        idNumber: holder.controls.idNumber.value,
        email: holder.controls.email.value,
        phone: holder.controls.phone.value,
        maritalStatus: holder.controls.maritalStatus.value,
        economicRegimeBeforeDivorce: holder.controls.economicRegimeBeforeDivorce.value,
        gender: holder.get('gender').value,
        nationality:
          holder.get('idType').value === 'DOC_TYP_NIF'
            ? 'ESP'
            : holder.get('nationality').value,
        country: holder.get('country').value,
      });

      this.onSaveForm.emit();
    }
  }

  savePersonalDataEconomic(holder: UntypedFormGroup, index: number) {
    this.resetValidator();
    const campos = [
      'monthlyIncome',
      'otherIncome',
      'companyName',
      'employmentSituation',
      'laborSeniority',
    ];
    let hasValid = true,
      hasDirty = false;
    for (const campo in campos) {
      if (!holder.controls[campos[campo]].valid) {
        hasValid = false;
      }
      if (holder.controls[campos[campo]].dirty) {
        hasDirty = true;
      }
    }
    if (hasDirty && hasValid) {
      Object.assign(this._userDataService.getUserData().level2Data.holders[index], {
        holderEmploymentData: {
          monthlyIncome: holder.controls.monthlyIncome.value,
          otherIncome: holder.controls.otherIncome.value,
          companyName: holder.controls.companyName.value.trim(),
          employmentSituation: holder.controls.employmentSituation.value,
          laborSeniority: holder.controls.laborSeniority.value,
        },
      });

      this.onSaveForm.emit();
    }
  }

  saveAddressHolder(address: UntypedFormGroup, index: number) {
    this.resetValidator();
    if (address.valid) {
      Object.assign(this._userDataService.getUserData().level2Data.holders[index], {
        holderAddress: address.value,
      });
      this.onSaveForm.emit();
    } else {
      for (const campo in address.controls) {
        address.controls[campo].markAsTouched();
      }
    }
  }

  confirmDeleteUser() {
    const titleModal = this.translate.instant(
      'app_advance_simulator_form_confirm_delete_holder_title',
    );
    const message = 'app_advance_simulator_form_confirm_delete_holder_msg';

    const data = {
      message: message,
      txtButtonCancel: 'btn_cancel',
    };
    const options: Object = {
      header: titleModal,
      showHeader: true,
      closeOnEscape: true,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
    };

    this.confirmationService.confirm(<any>{
      component: ModalGenericComponent,
      options: options,
      data: data,
      accept: (data) => {
        this.deleteUser();
      },
      reject: () => {},
    });
  }

  openToast(id: string) {
    const elementHTML = document.getElementById(id);
    elementHTML.focus();
  }

  private difetentDocument() {
    return () => {
      const firstHolder: any = this.titulares.controls[0];
      const secondHolder: any = this.titulares.controls[1];
      let isDiferent = true;

      if (
        secondHolder &&
        firstHolder.controls.idNumber.value.toLocaleLowerCase() ===
          secondHolder.controls.idNumber.value.toLocaleLowerCase()
      ) {
        isDiferent = false;
      }

      return of(isDiferent ? null : { equalDocument: true });
    };
  }

  private difetentEmail() {
    return () => {
      const firstHolder: any = this.titulares.controls[0];
      const secondHolder: any = this.titulares.controls[1];
      let isDiferent = true;

      if (
        secondHolder &&
        firstHolder.controls.email.value.toLocaleLowerCase() ===
          secondHolder.controls.email.value.toLocaleLowerCase()
      ) {
        isDiferent = false;
      }

      return of(isDiferent ? null : { equalEmail: true });
    };
  }
  private maxIncome(holder) {
    const monthlyIncome = holder.controls['holderEmploymentData'].controls.monthlyIncome
      .value
      ? holder.controls['holderEmploymentData'].controls.monthlyIncome.value
      : 0;
    const otherIncome = holder.controls['holderEmploymentData'].controls.otherIncome.value
      ? holder.controls['holderEmploymentData'].controls.otherIncome.value
      : 0;
    const totalValue = parseFloat(monthlyIncome) + parseFloat(otherIncome);
    return totalValue >= 1000000 ? { maxIncome: true } : null;
  }
}
